type IconProps = React.SVGProps<SVGSVGElement>;

const EyeClosed: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0456 11.6612L12.6014 14.813M7.94777 11.6597L7.39192 14.812M15.715 9.94567L17.497 13.0322M4.28206 9.94315L2.49146 13.0446M2.5001 8.19336C3.81357 9.81918 6.22151 11.875 10.0001 11.875C13.7788 11.875 16.1867 9.81919 17.5002 8.19338"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EyeClosed;
